import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import Axios from "axios";

import useState from "../../../Hooks/useState";
import PinCode from "../PinCode";
import languagePack from "../../../Utils/language";
import { HOST, CONTRACT_ADDRESS, CHAIN_ID, CHAIN_NAME, ETHERSCAN_TX_URL } from "../../../Utils/constants";
import globalContext from "../../../Hooks/globalContext";

const PageVIew = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const Container = ({ params }) => {
  const history = useHistory();
  const { user, language, web3, modal, contract, httpHeader } = useContext(globalContext);

  const pin = useState("");
  const isLoading = useState(false);
  const error = useState(null);

  const authentication = async () => {
    const { data } = await Axios.post(`${HOST}/user/otp/validation`, { pin: pin.state }, httpHeader());

    if (data.status) {
      if (params.type === "LCMS") {
        const {
          data: { locked, staking },
        } = await Axios.post(`${HOST}/api/available/token`, { to: params.to, type: "lcms" }, httpHeader());

        const lcmBalance = await contract.state.lcms.methods.balanceOf(user.state.address).call();
        const lcm = await web3.utils.fromWei(lcmBalance);

        if (Number(lcm) - Number(locked.sum - locked.available_amount) - Number(staking.sum) < Number(params.amount)) {
          modal.setState(languagePack("현재 송금 가능 금액보다 보낼 금액이 더 큽니다.", language.state));
          pin.setState("");
          isLoading.setState(false);
          history.goBack();
          return;
        }
      }

      if (params.type === "ESG") {
        const {
          data: { locked, staking },
        } = await Axios.post(`${HOST}/api/available/token`, { to: params.to, type: "esg" }, httpHeader());

        const esgBalance = await contract.state.esg.methods.balanceOf(user.state.address).call();
        const esg = await web3.utils.fromWei(esgBalance);

        if (Number(esg) - Number(locked.sum - locked.available_amount) - Number(staking.sum) < Number(params.amount)) {
          modal.setState(languagePack("현재 송금 가능 금액보다 보낼 금액이 더 큽니다.", language.state));
          pin.setState("");
          isLoading.setState(false);
          history.goBack();
          return;
        }
      }

      if (params.type === "MallBuy") {
        const {
          data: { locked, staking },
        } = await Axios.post(`${HOST}/api/available/token`, null, httpHeader());

        const lcmBalance = await contract.state.lcms.methods.balanceOf(user.state.address).call();
        const lcm = await web3.utils.fromWei(lcmBalance);

        if (Number(lcm) - Number(locked.sum - locked.available_amount) - Number(staking.sum) < Number(params.amount)) {
          modal.setState(languagePack("현재 결제 가능 금액보다 결제할 금액이 더 큽니다.", language.state));
          pin.setState("");
          isLoading.setState(false);
          history.goBack();
          return;
        }
      }

      let to = params.to;
      if (params.idSend) {
        const requestBody = { type: params.type, email: params.to };
        const { data } = await Axios.post(`${HOST}/api/wallet/check`, requestBody, httpHeader());
        if (!data.status) {
          switch (data.code) {
            case "me":
              modal.setState(languagePack("자기 자신에게는 보낼 수 없습니다.", language.state));
              break;
            case "server":
              modal.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
              break;
            case "invalid":
              modal.setState(languagePack("받는 사람 E-Mail이 존재하지 않습니다.", language.state));
              break;
          }
          pin.setState("");
          isLoading.setState(false);
          history.goBack();
          return;
        } else {
          to = data.content;
        }
      }

      const count = await web3.eth.getTransactionCount(user.state.address, "pending");
      const gasPrice = params.gas.toString();
      const weiGasPrice = web3.utils.toWei(gasPrice, "gwei");
      const convertedGas = web3.utils.fromWei(`85000`, "gwei");
      const hexGasPrice = web3.utils.toHex(weiGasPrice);
      let rawTransaction = null;

      switch (params.type) {
        case "ETH":
          rawTransaction = {
            from: user.state.address,
            gasPrice: hexGasPrice,
            gasLimit: web3.utils.toHex(21000),
            to: to,
            value: web3.utils.toHex(web3.utils.toWei(params.amount.toString(), "ether")),
            chainId: web3.utils.toHex(CHAIN_ID),
            nonce: web3.utils.toHex(count),
          };
          break;
        case "ESG":
          rawTransaction = {
            from: user.state.address,
            gasPrice: hexGasPrice,
            gasLimit: web3.utils.toHex(85000),
            to: to,
            value: web3.utils.toHex(web3.utils.toWei(params.amount.toString(), "ether")),
            chainId: web3.utils.toHex(CHAIN_ID),
            nonce: web3.utils.toHex(count),
          };
          break;
        // case "USDT":
        //   rawTransaction = {
        //     from: user.state.address,
        //     gasPrice: hexGasPrice,
        //     gasLimit: web3.utils.toHex(210000),
        //     to: CONTRACT_ADDRESS[1].address,
        //     value: "0x0",
        //     data: contract.tether.methods.transfer(to, web3.utils.toWei(params.amount)).encodeABI(),
        //     nonce: web3.utils.toHex(count),
        //   };
        // break;
        case "LCMS":
          rawTransaction = {
            from: user.state.address,
            gasPrice: hexGasPrice,
            gasLimit: web3.utils.toHex(85000),
            to: CONTRACT_ADDRESS[0].address,
            value: "0x0",
            data: contract.state.lcms.methods.transfer(to, web3.utils.toWei(params.amount)).encodeABI(),
            nonce: web3.utils.toHex(count),
          };
          break;
        case "MallBuy":
          rawTransaction = {
            from: user.state.address,
            gasPrice: hexGasPrice,
            gasLimit: web3.utils.toHex(85000),
            to: CONTRACT_ADDRESS[0].address,
            value: "0x0",
            data: contract.state.lcms.methods.transfer(to, web3.utils.toWei(params.amount)).encodeABI(),
            nonce: web3.utils.toHex(count),
          };
          break;
      }

      const requestBody = {
        rawTransaction,
        chain: CHAIN_NAME,
      };

      const { data } = await Axios.post(`${HOST}/ethereum/transaction/wrap`, requestBody, httpHeader());
      if (data.status) {
        web3.eth.sendSignedTransaction(data.hash, async (error, hash) => {
          if (params.type === "MallBuy") {
            const orderBody = {
              ...params,
              hash,
              error: error ? error.toString() : null,
            };
            const { data } = await Axios.post(`${HOST}/market/order`, orderBody, httpHeader());
          }

          const logBody = {
            sendType: params.type === "MallBuy" ? "LCMS" : params.type,
            status: error,
            send: user.state.address,
            receive: to,
            amount: params.amount,
            fee: convertedGas * gasPrice,
            hash,
            error: error ? error.toString() : null,
          };
          if (error) {
            const { data } = await Axios.post(`${HOST}/wallet/log`, logBody, httpHeader());
            modal.setState(error.toString());
          } else {
            const { data } = await Axios.post(`${HOST}/wallet/log`, logBody, httpHeader());
            pin.setState("");
            isLoading.setState(false);
            history.push(`/market/${params.log.productId}`);
            modal.setState(languagePack("주문이 정상적으로 처리되었습니다.", language.state));
          }
        });
      } else {
        error.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
      }
    } else {
      switch (data.code) {
        case "blocked":
          error.setState(languagePack("잠금상태입니다. 잠시 후에 다시 시도해주세요.", language.state));
          break;
        case "block":
          error.setState(languagePack("비밀번호 3회 오류로 5분간 송금이 제한됩니다.", language.state));
          break;
        case "invalid":
          error.setState(languagePack("잘못된 비밀번호입니다.", language.state));
          break;
        case "server":
          error.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
          break;
      }
    }
    pin.setState("");
    isLoading.setState(false);
  };

  useEffect(() => {
    if (pin.state.length > 5) {
      pin.setState("");
      isLoading.setState(true);
      authentication();
    }
  });

  return (
    <PageVIew>
      <PinCode
        goBack={() => {
          history.goBack();
        }}
        error={error.state}
        isLoading={isLoading.state}
        pin={pin}
        title={languagePack("OTP 인증번호 6자리를 입력하세요.", language.state)}
      />
    </PageVIew>
  );
};

export default Container;
